import { useCallback, useState } from 'react';
import { useCartContext } from '../context/cartContext/useCartContext';

export function useFreeGiftModal() {
  const { setIsPopupOpen } = useCartContext();
  const [isVisible, setVisible] = useState(false);

  const showModal = useCallback(() => {
    setIsPopupOpen(true);
    setVisible(true);
  }, [setIsPopupOpen]);

  const hideModal = useCallback(() => {
    setIsPopupOpen(false);
    setVisible(false);
  }, [setIsPopupOpen]);

  return {
    isVisible,
    showModal,
    hideModal,
  };
}
